(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('daily', {
            parent: 'script',
            url: '/daily',
            data: {
                pageTitle: 'global.menu.system.daily'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/daily/daily.html',
                    controller: 'DailyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('daily');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
